import B_NA from './NA';
import B_Other from './Other';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const NA_SITES: string[] = ['us', 'ca', 'za'];

    return <>{NA_SITES.includes(locale) ? <B_NA /> : <B_Other />}</>;
}
